// extracted by mini-css-extract-plugin
export var muteToggle = "vimeoPlayer-module--mute-toggle--lWsC0";
export var vimeoPlayer = "vimeoPlayer-module--vimeo-player--kyD3U";